<template>
  <transition name="el-zoom-in-center">
    <el-dialog title="稽查码取证图片" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-carousel height="500px" :autoplay="false">
        <el-carousel-item v-for="(item, i) in dataarr" :key="i">
          <el-row>
            <el-col :span="12">
              <el-tooltip v-if="item.imageUrlList && item.imageUrlList.length > 0" content="点击查看全部取证照片" effect="light"
                placement="right-start">
                <el-image style="height: 600px" :src="item.imageUrlList[0]" :preview-src-list="item.imageUrlList" />
              </el-tooltip>
              <span v-if="!item.imageUrlList || item.imageUrlList.length === 0">无取证图片</span>
            </el-col>
            <el-col :span="12">
              备注：
              {{ item.remark }}
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </transition>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { productlist } from "@/api/base";
import { selectcorrect } from "@/api/physical";
export default {
  components: { PanThumb },
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null
        };
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      dataarr: [],
    }
  },
  mounted() {

  },
  methods: {
    // 获取码稽查列表
    Tabledata(qrcode) {
      selectcorrect({
        qrcode: qrcode,
        page: 1,
        pageSize: 99
      }).then(response => {
        this.dataarr = response.data.list;
        console.log(this.dataarr);
        for (let i = 0; i < this.dataarr.length; i++) {
          this.dataarr[i].show = false;
          this.dataarr[i].imageUrlList = this.dataarr[i].imageName ? this.dataarr[i].imageName.split(',').map(url => decodeURIComponent(url)) : [];
        }
        console.log(this.dataarr);
        this.dialogVisible = true;
      });
    },
    handleClose(done) {
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped></style>
